import Loadable from '../../components/loadable';

const GymIncomeCategories = Loadable({
  loader: () => import('../../pages/account_profile/gym_income_categories'),
});

angular.module('gym').value('GymIncomeCategories', GymIncomeCategories);
